<script setup lang="ts">

import { onMounted, onBeforeUnmount } from "vue";

import mlcontour from "maplibre-contour";
import * as maplibregl from "maplibre-gl";
import { addLayer, injectMap, removeLayer, removeSource } from "@/utils/MapUtils";

const $map = injectMap()

function initMap() {
	var demSource = new mlcontour.DemSource({
		url: "https://tiles-eu.stadiamaps.com/data/terrarium/{z}/{x}/{y}.png",
		encoding: "terrarium", // "mapbox" or "terrarium" default="terrarium"
		maxzoom: 12,
		worker: true, // offload isoline computation to a web worker to reduce jank
		cacheSize: 100, // number of most-recent tiles to cache
		timeoutMs: 10000, // timeout on fetch requests
	});
	demSource.setupMaplibre(maplibregl);

	$map.addSource("contour-source", {
		type: "vector",
		tiles: [
			demSource.contourProtocolUrl({
				// convert meters to feet, default=1 for meters
				multiplier: 1,
				overzoom: 1,

				thresholds: {
					// zoom: [minor, major]
					8: [200, 1000],
					10: [200, 1000],
					11: [100, 500],
					12: [50, 200],
					13: [20, 100],
				},
				// optional, override vector tile parameters:
				// contourLayer: "contours",
				// elevationKey: "ele",
				// levelKey: "level",
				// extent: 4096,
				// buffer: 1,
			}),
		],
		maxzoom: 15,
	});

	addLayer($map, {
		id: "contour-lines",
		type: "line",
		source: "contour-source",
		"source-layer": "contours",
		paint: {
			"line-color": "rgba(0,0,0, 18%)",
			// level = highest index in thresholds array the elevation is a multiple of
			"line-width": ["match", ["get", "level"], 1, 1, 0.5],
		},
	}, false, "water");
	addLayer($map, {
		id: "contour-labels",
		type: "symbol",
		source: "contour-source",
		"source-layer": "contours",
		filter: [">", ["get", "level"], 0],
		layout: {
			"symbol-placement": "line",
			"text-size": 10,
			"text-field": ["concat", ["number-format", ["get", "ele"], {}], ""],
			"text-font": ["Stadia Semibold"],
		},
		paint: {
			"text-halo-color": "white",
			"text-halo-width": 1,
		},
	}, false, "water");
}

onMounted(() => {
	initMap();
});

onBeforeUnmount(() => {
	removeLayer($map, "contour-lines");
	removeLayer($map, "contour-labels");
	removeSource($map, "contour-source");
});

</script>

<template></template>

<style></style>